<template>
  <div v-if="active" class="mb-1">
    <div class="form-check" v-if="module.heureka.enabled && module.heureka.show">
      <input id="overeno_heureka_consent" type="checkbox" class="form-check-input" :checked="consents.customerSatisfactionSurvey" @change="updateValueCustomerSatisfactionSurvey">
      <label class="form-check-label" for="overeno_heureka_consent">
        {{ module.heureka.text }}
      </label>
    </div>
    <div class="form-check" v-if="module.zbozi.enabled && module.zbozi.show">
      <input id="overeno_zbozi_consent" type="checkbox" class="form-check-input" :checked="consents.independentShopRating" @change="updateValueIndependentShopRating">
      <label class="form-check-label" for="overeno_zbozi_consent">
        {{ module.zbozi.text }}
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      consents: state => state.consents,
      modules: state => state.config.modules,
    }),
    module () {
      return this.modules.overeno ? this.modules.overeno : null;
    },
    active () {
      return !!(this.module && ((this.module.heureka.enabled && this.module.heureka.show) || (this.module.zbozi.enabled && this.module.zbozi.show)));
    },
  },
  methods: {
    updateValueCustomerSatisfactionSurvey (e) {
      this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', e.target.checked);
    },
    updateValueIndependentShopRating (e) {
      this.$store.commit('SET_CONSENT_INDEPENDENT_SHOP_RATING', e.target.checked);
    }
  },
  mounted: function() {
    if (this.active === false) {
      return;
    }
    if (this.module.heureka.enabled && this.module.heureka.show) {
      this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', this.module.heureka.checked);
    }
    if (this.module.zbozi.enabled && this.module.zbozi.show) {
      this.$store.commit('SET_CONSENT_INDEPENDENT_SHOP_RATING', this.module.zbozi.checked);
    }
  },
};
</script>
